<mat-form-field class="user-control-container" appearance="outline">
	<mat-label translate="reviewers"></mat-label>
	<mat-chip-list #chipList [attr.aria-label]="'modal-video-share-dialog_user-select-aria-label' | translate">
		<mat-chip
			*ngFor="let user of selectedUsers.value"
			[ngClass]="{ 'invalid': user.invalid }"
			[selectable]="selectable"
			[removable]="removable"
			(removed)="remove(user)">
			{{ getChipDisplay(user) }}
			<button matChipRemove *ngIf="removable">
				<i class="ficon-app-x"></i>
			</button>
		</mat-chip>
		<input
			placeholder="{{'modal-video-share-dialog_placeholder' | translate}}"
			#userInput
			data-cy="users-field"
			[formControl]="userInputCtrl"
			[matAutocomplete]="auto"
			[matChipInputFor]="chipList"
			[matChipInputSeparatorKeyCodes]="separatorKeysCodes"
			(matChipInputTokenEnd)="add($event)">
	</mat-chip-list>
</mat-form-field>
<mat-error *ngIf="selectedUsers.hasError('invalidChip')">
	{{ getValidationError() }}
</mat-error>
<mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event);">
	<mat-option *ngFor="let user of filteredUsers | async" [value]="user">
		{{ user.first_name }} {{ user.last_name }}
	</mat-option>
</mat-autocomplete>
